module.exports = __webpack_public_path__ + "img/co.bfda7e86.svg";